import { Component, OnInit } from '@angular/core';
import { OkAloneService } from '../../../ok-alone.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  timer:any = null;

  constructor(private router: Router,public okService:OkAloneService) { 

    //console.log("Start Loading");

  }

  ngOnInit(): void {

    this.timer = setTimeout( () => {

      this.goToHome();

    }, 3000 );

  }

  ngOnDestroy(): void {

    //console.log("Loading Destroyed");
    clearInterval(this.timer);

  }

  goToHome(){
    if(this.okService.isLoggedIn()){
      //console.log("Go to home from loading");
      this.router.navigateByUrl('/home');
    }else{
      //console.log("Go to login from loading");
      this.router.navigateByUrl('/login');
    }
  }

}
